import Auth from "@system/config/auth";
// import Helper from "src/support/Helper";
import Base from "src/service/Base";
import Api from "src/service/APIHandler";
const API = new Api({});

class DesignHubAPICall extends Base {
    registerUser = async (params = {}) => {
        let res = {};
        let param = {}
        param.data = params
        try {
            await API.post(Auth.REGISTER_USER_URL, param).then((resHer) => {
                if (resHer.data) {
                    res = resHer?.data
                }
            });
        } catch (e) {
            res = e?.response?.data
        }
        return res;
    };

    getCountryList = async () => {
        let res = {};
        await API.get(Auth.GET_COUNTRY_LIST, {}).then((resHer) => {
          if (resHer?.data?.data) {
              res = resHer.data?.data
              if(res?.length > 0)
              {
                res = res.map(x => ({...x, label: x?.displayValues, value:x?.countryCode}))
              }
          }
        });
        return res;
      };

      getCrossReferenceParts = async (ERPMFRPartNumber) => {
        let res = {};
        await API.get(Auth.SEARCH_CROSS_REFERENCE_PARTS_URL+'?erpMFRPartNumber='+ERPMFRPartNumber, {}).then((resHer) => {
          res = resHer?.data?.data
        });
        return res;
      }
}

export default DesignHubAPICall;